import React from 'react';

interface IProps {
    size: number;
    className?: string;
}

const IconInputSliders = (props: IProps) => {
    return (
        <div className={props?.className} style={{ height: `${props.size}px` }}>
            <svg
                width={`${props.size}px`}
                height={`${props.size}px`}
                version="1.1"
                viewBox="0 0 1200 1200"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g>
                    <path d="m948 216h192v72h-192z" />
                    <path d="m924 252c0 59.648-48.352 108-108 108s-108-48.352-108-108 48.352-108 108-108 108 48.352 108 108" />
                    <path d="m60 216h624v72h-624z" />
                    <path d="m864 912h276v72h-276z" />
                    <path d="m840 948c0 59.648-48.352 108-108 108s-108-48.352-108-108 48.352-108 108-108 108 48.352 108 108" />
                    <path d="m60 912h540v72h-540z" />
                    <path d="m516 564h624v72h-624z" />
                    <path d="m492 600c0 59.648-48.352 108-108 108s-108-48.352-108-108 48.352-108 108-108 108 48.352 108 108" />
                    <path d="m60 564h192v72h-192z" />
                </g>
            </svg>
        </div>
    );
};

export default IconInputSliders;
